import { CheckCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { businessAtom } from '../../../atoms/Atoms';
import DraggableTable from './shared-components/Draggable-Table';

function ProductSorting() {
  const business = useRecoilValue(businessAtom);
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('category_sorting')}
        tags={
          <Tag
            color="#2db7f5"
            icon={business ? <CheckCircleOutlined /> : <SyncOutlined spin />}
          >
            {business ? business.name : `${t('loading')}...`}
          </Tag>
        }
      />
      <DraggableTable />
    </>
  );
}

export default ProductSorting;
